export enum Events {
  Insert = 'INSERT',
  Remove = 'REMOVE',
  Modify = 'MODIFY',
  DomainVerified = 'DOMAIN_VERIFIED',
  Refresh = 'REFRESH',
}
